export default __webpack_public_path__ + "static/media/euro.16ee92da.svg";